import { PropTypes } from "prop-types";
import { useEffect, useState } from "react";

//utils
import {
  shortDisplayTime,
  updateTimeWithOffset,
  getStartfDayUTCFormat,
  convertTimestampToLocalTime,
} from "../../utils/displayTime";
import timeFilterConfig from "../config/time-filter-config";
import {
  showComparisonText,
  validateTimePeriodSelected,
  validateTimePeriodSelectedSidebar,
  isSecurityPage,
  isCustom,
  getLocalStorageFlag,
} from "../../utils/common";

//style
import css from "../genericMagneticStyle.less";
import { useI18n } from "../../i18n/useI18n";

const TimeStamp = ({
  globalFilter,
  sideBar,
  options = timeFilterConfig,
  isReport,
  reportData = {},
  hideCompareText,
}) => {
  const { tGenerics } = useI18n("generics");
  const { timeFilter, sideBarTimeFilter, timePeriodSelected } = globalFilter;
  const isDaySavingTime = false;
  const displayComparison = showComparisonText(location);
  const [time, setTime] = useState(timePeriodSelected);
  const formatedCurrentTime = reportData?.current_period_end
    ? updateTimeWithOffset(
        reportData.created_by,
        reportData.current_period_end,
        isDaySavingTime,
      )
    : timeFilter?.current_period[1];
  const formatedPrevTime = reportData?.current_period_start
    ? updateTimeWithOffset(
        reportData.created_by,
        reportData.current_period_start,
      )
    : timeFilter?.current_period[0];
  let selectedTimeframe = sideBar
    ? validateTimePeriodSelectedSidebar(globalFilter)
    : validateTimePeriodSelected(globalFilter);
  const currentTime = shortDisplayTime(
    sideBar
      ? selectedTimeframe === "CUSTOM"
        ? getStartfDayUTCFormat(sideBarTimeFilter.current_period[1])
        : sideBarTimeFilter.current_period[1]
      : selectedTimeframe === "CUSTOM"
        ? getStartfDayUTCFormat(timeFilter.current_period[1])
        : formatedCurrentTime,
  );
  const prevTime = shortDisplayTime(
    sideBar
      ? selectedTimeframe === "CUSTOM"
        ? getStartfDayUTCFormat(sideBarTimeFilter.current_period[0])
        : sideBarTimeFilter.current_period[0]
      : selectedTimeframe === "CUSTOM"
        ? getStartfDayUTCFormat(timeFilter.current_period[0])
        : formatedPrevTime,
  );

  let startTimeFormatted = "";
  let endTimeFormatted = "";
  let timeZoneAbbr = "";

  if (isReport) {
    ({ startTimeFormatted, endTimeFormatted, timeZoneAbbr } =
      convertTimestampToLocalTime(
        reportData.current_period_start,
        reportData.current_period_end,
        reportData.time_range_type,
      ));
  }

  useEffect(() => {
    if (isSecurityPage() && isCustom(timePeriodSelected)) {
      setTime(getLocalStorageFlag("timePeriodSelected"));
    } else {
      setTime(globalFilter.timePeriodSelected);
    }
  }, [globalFilter.timePeriodSelected]);

  useEffect(() => {
    if (sideBar && globalFilter?.sideBarTimeFilter?.timePeriodSelected) {
      setTime(globalFilter?.sideBarTimeFilter?.timePeriodSelected);
    }
  }, [globalFilter.sideBarTimeFilter]);

  return (
    <div className={`${css["timestamp"]} hbr-type-body4`}>
      {!isReport && (
        <>
          <span className="text">{prevTime}</span>
          {selectedTimeframe === "CUSTOM" && (
            <span className="text">{tGenerics("utcTimeSuffix")}</span>
          )}
          <span className="text">{" - "}</span>
          <span className="text">{currentTime} </span>
          {selectedTimeframe === "CUSTOM" && (
            <span className="text">{tGenerics("utcTimeSuffix")}</span>
          )}
        </>
      )}
      {displayComparison && !hideCompareText && !isReport && (
        <span
          className="text compare-label"
          data-testid="compare-label-timestamp"
        >
          {tGenerics("timeFilterCustomCompareWith")}
          {options ? options[time].text : timeFilterConfig[time].text}
        </span>
      )}
      {isReport && (
        <>
          <span className="text">{startTimeFormatted}</span>
          <span className="text">{" - "}</span>
          <span className="text">{endTimeFormatted}</span>
          <span className="text">{` ${timeZoneAbbr}`}</span>
        </>
      )}
    </div>
  );
};

TimeStamp.propTypes = {
  globalFilter: PropTypes.object,
  sideBar: PropTypes.bool,
  options: PropTypes.object,
  isReport: PropTypes.bool,
  reportData: PropTypes.object,
  hideCompareText: PropTypes.bool,
};

export default TimeStamp;
